import { recordCalibrationEvent } from '@framework/utils/operationCalibration';
import type { DataSnapshot, Reference } from '../RefBuilder';
import { RefBuilder } from '../RefBuilder';
import type { DBPath } from 'balus-common';

export class TextRepository<T extends string = string> {
  private callback: ((value: DataSnapshot) => void) | undefined = undefined;
  private readonly ref: Reference;

  constructor(path: DBPath) {
    this.ref = RefBuilder.ref(path);
  }

  addListener(callback: (value: T | null) => void): void {
    this.callback = (snapshot) => {
      const j = snapshot.val() as T | null;
      callback(j);
    };

    this.ref.on('value', this.callback);
  }

  removeListener(): void {
    // この Repository の addListener() で登録したリスナーだけを対象に、リスン解除する。
    this.ref.off('value', this.callback);
    this.callback = undefined;
  }

  async get(): Promise<T | null> {
    const snapshot = await this.ref.once('value');

    return snapshot.val();
  }

  async save(value: T): Promise<void> {
    recordCalibrationEvent('write.text');
    await this.ref.set(value);
  }

  async delete(): Promise<void> {
    await this.ref.set(null);
  }
}
